import styled from "styled-components";



export const SlidebarHeader = styled.div`
    /* position: absolute */
    height: 100vh;
`

export const SliderButton = styled.div`
    position: absolute;
    right: 50%;
    bottom: 14%;

    & svg{
        cursor: pointer;
    }
`